var dd = require('react-dd');

module.exports = dd.createClass({
	render: function(){
		return dd.img({src: '//d1wyxf4lkw4102.cloudfront.net/ui/loading.gif'});
	}
});



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/LoadingBar.js
// module id = 85
// module chunks = 0 1 2 3 4